  import axios              from "axios";
  import { api }            from "../_constants";
  import handleResponse     from "./handleResponse";
  import getVoucherUser     from "./handleVoucherUser";
  import getVoucherData     from "./handleVoucherData";
//import getAppStats        from "./handleAppStats";
  import getAppId           from "./handleAppId";
//import getWebServiceCount from "./handleWebServiceCount";

export const wu_CountriesStatesCitiesService = {
  wu_getCountries,
  wu_should_getCountries,
  wu_getStates,
  wu_getCities
};
//----------------------------------------------------------------------------------------------------
function wu_getCountries(reqData) {
  const methName = "wu_getCountries ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/getCountries";

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {

  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      if(resData && resData.returnCode===0){
        localStorage.setItem("countries",                  JSON.stringify(resData));
        localStorage.setItem("countries_RetrieveLastDate", new Date());
      }
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
function wu_should_getCountries(reqData) {
  //console.log("countries_RetrieveLastDate = "+new Date());
  //console.log("countries_RetrieveLastDate = "+localStorage.getItem("countries_RetrieveLastDate"));

  if(api.cache_Countries_enabled === false){
    return true;
  }

  let countries = {};
  try { countries = JSON.parse(localStorage.getItem("countries")); }catch(err){;}
  if(countries===null || (typeof countries === "undefined")){
    return true;
  }
  if(!countries.countries || countries.countries.length===0){
    return true;
  }

  let UserWSRetrieveLastDate = new Date(localStorage.getItem("countries_RetrieveLastDate"));
  let dateNow                = new Date();
  if(UserWSRetrieveLastDate===null){
      return true;
  }
  else{
      let secondsDiff = (dateNow.getTime()-UserWSRetrieveLastDate.getTime())/1000;
      let minsDiff    = (secondsDiff/60);
      if(minsDiff<0){minsDiff = -minsDiff;}
      if(minsDiff>api.cache_Countries_TTL_min){ return true;  }
      else                                    { return false; }
  }
}
//----------------------------------------------------------------------------------------------------
function wu_getStates(reqData) {
  const methName = "wu_getStates ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/getStates?country="+reqData.country;

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {

  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      var resData2 = {returnCode:0, returnText:"", states:[]};
      for(let i=0; i<resData.states.length; ++i){
        if(resData.states[i]["ctry_wu_id"]===reqData.country){
          resData2.states.push(resData.states[i]);
        }
      }
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData2;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
function wu_getCities(reqData) {
  const methName = "wu_getCities ";
  const localUrl = api.url + "/wbrestservices-1.0.0/wbservice/getCities?country="+reqData.country+"&state="+reqData.state;

  const config = {
    timeout: api.netTimeout,
    headers: {
      "Content-Type"                : "application/json",
      "Accept"                      : "application/json",
    //"username"                    : getVoucherUser(api.url),//api.username,
    //"password"                    : getVoucherData(api.url),//api.password,
      "appType"                     : api.appType,
      "appId"                       : getAppId(api.appId),//api.appId,
      "platform"                    : api.platform,
      "channel"                     : api.platformWeb,
    //"appStats"                    : getAppStats(api.webappENV),
    //"webServiceCount"             : getWebServiceCount(),
      "appVersion"                  : api.appVersion,
      "apiVersion"                  : api.apiVersion,
      "lang"                        : localStorage.getItem("lang"),
      "Access-Control-Allow-Origin" : api.allowOrigin_val,
      "Cache-control"               : "no-cache, no-store, must-revalidate", //ie11 cache ajax
      "Pragma"                      : "no-cache",
      "Expires"                     : "0",
      "wbDate"                      : api.buildNumber+"/"+api.buildDateAPI,
      "wbEnv"                       : api.webappENV,
    }
  };
  if(api.use_uph){
    config.headers.username = getVoucherUser(api.url);
    config.headers.password = getVoucherData(api.url);
  }
  const data = {

  };
  if(api.print_HTTP_URL){console.log(methName+localUrl);}
  return axios
    .post(localUrl, data, config)
    .then(handleResponse)
    .then(resData => {
      if(api.print_HTTP_RESP_BODY){console.log(resData);}
      return resData;
    })
    .catch(err => {
      return Promise.reject(err);
    });
}
//----------------------------------------------------------------------------------------------------
